import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface Category {
  id: string;
  name: string;
  description: string;
  image: string;
  count: number;
  created_at: string;
}

export interface Product {
  id: string;
  title: string;
  description: string;
  long_description?: string | null;
  highlights?: string[] | null;
  price: string;
  discounted_price?: string | null;
  image: string;
  images: string[];
  category: string;
  badge?: string | null;
  is_featured: boolean;
  purchase_options: PurchaseOption[];
  created_at: string;
}

export interface PurchaseOption {
  id: string;
  icon: string;
  label: string;
  subLabel: string;
  url: string;
  colorClass: string;
}

export interface ContactSubmission {
  id: string;
  name: string;
  email: string;
  phone?: string | null;
  subject?: string | null;
  message: string;
  status: 'new' | 'read' | 'replied';
  created_at: string;
}

export interface NewsletterSubscriber {
  id: string;
  email: string;
  status: 'active' | 'unsubscribed';
  source: string;
  created_at: string;
}
